import { render } from "./retail-support-page.vue?vue&type=template&id=57f7c155"
const script = {}

import exportComponent from "/var/www/tap-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__